import { render } from "./AddEntry.vue?vue&type=template&id=bc0019f8"
import script from "./AddEntry.vue?vue&type=script&lang=js"
export * from "./AddEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__